import { getConfigValue } from "./config";

export default function Url(configUrlKey, endpoint) {
  if (!!endpoint && endpoint.slice(0, 1) === "/") {
    endpoint = endpoint.substr(1);
  }

    let host = getConfigValue(configUrlKey);
  if (!host) {
      return host + endpoint;
  }
  if (!!host && host.slice(-1) !== "/") {
    host += "/";
  }
  return host + endpoint;
}
